import React from 'react'
import BrandPrinterSetup from '../BrandPrinterSetup'
import DownloadDriverForm from '../DownloadDriverForm'

const BrForm = () => {
  return (
    <>
      
             <DownloadDriverForm
        brand="BROTHER"
        image="https://support-printers.netlify.app/img/Brother-Logo.png"
      />
    </>
  )
}

export default BrForm
